import { HTMLAttributes, type FC } from "react";
import clsx from "clsx";

export interface SafeAreaStickyTopProps extends HTMLAttributes<HTMLDivElement> {
    offsetTop?: string;
}

export const SafeAreaStickyTop: FC<
    React.PropsWithChildren<SafeAreaStickyTopProps>
> = ({ children, className, offsetTop = "0.5px", ...rest }) => {
    return (
        <div
            {...rest}
            className={clsx("sticky z-[100]", className)}
            style={{
                top: `-${offsetTop}`,
            }}
        >
            {children}
        </div>
    );
};

export default SafeAreaStickyTop;
